import * as React from "react";
import { FileUploadSection } from "../../generic/fileUploadSection";
import TocDropdown from "../../../generic/tocDropdown";
import { useState } from "react";
import Checkbox from "../../../generic/checkbox";
import {getinvAccDet} from "../../../service/login/loginService"
let invOnlyAcc = getinvAccDet();

var bankDropdownMenu: Array<any> = [
  {
    value: "Cancelled Cheque",
    display: "Cancelled Cheque",
  },
  {
    value: "Bank Statement",
    display: "Bank Statement",
  },
];
export const BankUpload = (props: any) => {
  const [dropValChanged, setDropValChanged] = React.useState(false);
  const [selectedSegincomeProof, setSelectedSegincomeProof] = React.useState({
    value: "Bank Statement",
    display: "Bank Statement",
  });
  const [fileDetails, setFileDetails] = useState<any>(props.fileDet || null);

  React.useEffect(() => {
    props.onSubmit(fileDetails);
  }, [fileDetails]);
  const handleSubmit = (fileDetails: any) => {
    setDropValChanged(false);

    if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
      var actualbase64Data = fileDetails.base64Data.split(",");
      setFileDetails({
        fileName: fileDetails.docFile,
        base64Data: actualbase64Data[1],
        fileType: selectedSegincomeProof.value,
      });
    } else {
      setFileDetails({
        fileName: "",
        base64Data: "",
        fileType: "",
      });
    }
  };
  return (
    <>
      <div
        className="bank_proof"
        style={{
          pointerEvents:
            props.newBankDet.submitted || props.loader ? "none" : "all",
        }}
      >
        <div className="bank_proof__text">
          <label className="input-label input-label--head">Bank Proof </label>
          <p>
            Scanned copy of Bank proof for account {props.newBankDet.accNo}.
            <br />
            Document should have your Name, Account Number, IFSC and MICR code
            clearly visible.
          </p>
        </div>
        <div>
          <div className="custom--row">
            <div className="custom-col">
              <TocDropdown
                selectedValue={selectedSegincomeProof.value}
                dropdownOptions={bankDropdownMenu ? bankDropdownMenu : []}
                onSelect={(val: any) => {
                  let value = bankDropdownMenu.filter((ele) => {
                    if (ele.value === val) return ele;
                  });
                  setDropValChanged(true);
                  setSelectedSegincomeProof(value[0]);
                  setFileDetails({
                    fileName: "",
                    base64Data: "",
                    fileType: "",
                  });
                }}
                isSearchable={false}
              />
            </div>
            <div className="custom-col"></div>
          </div>

          <FileUploadSection
            disableCross={false}
            fileType={["tif", "tiff", "pdf", "jpg", "jpeg"]}
            dropValChanged={dropValChanged}
            onSubmit={handleSubmit}
            fileName={props.fileDet.fileName}
            fileSize={1048576}//1MB size
          />
          {!props.fileDet.fileName && (
            <p className="text-indicator small--text-indicator noSpaceIndicator">
              Kindly upload clear colour image of original documents of proof of
              bank
            </p>
          )}
          {/* {props.newBankDet.submitted && props.autoQC === "No" && (
            <div className="bankVerify">
              <h2 className="text-center">Verification in process</h2>
              <h4 className="field-subHead text-indicator">
                We have received your request, it’s under verification and will be completed within one working day. 
                After Successful verification we will send an email to complete E Sign.
              </h4>
            </div>
          )} */}
          <div>
            <div className="space-mt-2">
              <Checkbox
                checked={props.userConsent}
                onChange={async () => {
                  props.setConsent(!props.userConsent)}}
                name="UserConsent"
              >
                <span className="font-14 bold-text warm-grey-eight-text">I further confirm that below points verified by self</span>           
              </Checkbox>
            </div>
            <ul className="circle-list marker-mg-r10 font-RobotoCR">
              { selectedSegincomeProof.value==="Bank Statement" && <div className="pd-l45">
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Original Bank statement should be uploaded. If photocopy is uploaded, then the same will be rejected</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Latest 3 months transaction records required</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Name, Account Number, IFSC/MICR code should be mentioned in the bank statement and bank details should match with Bank statement</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Bank statement should not be password protected</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Name in Trading account, Bank account and Aadhar should match and you should be 1st holder in this bank.</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">If Bank statement is not computer generated, then stamp and signature of Bank official required.</span></li>
              </div>}
              { selectedSegincomeProof.value==="Cancelled Cheque" && <div className="pd-l45">
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Original cheque scanned copy should be uploaded. If photocopy is uploaded, then the same will be rejected.</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Cheque should have preprinted details like Name, Account Number, IFSC Code & MICR code and bank details should match with Cheque.</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">If cheque does not have preprinted details then submit bank statement as proof.</span></li>
              <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Name in Trading account, Bank account and Aadhar should match and you should be 1st holder in this bank.</span></li>
              </div>}
            </ul>
            <div style={{ display: invOnlyAcc ? 'block' : 'none' }}>
              <p className="text-indicator small--text-indicator noSpaceIndicator space-mt-2 red_text">Note: 
              <span className="pd-l45">
                <ul className="circle-list marker-mg-r10 font-RobotoCR pd-l45">
                <li className="font-18 red"><span className="font-12 red_text">For Fresh MF folio created on BSE Star MF, new bank details will only be considered.</span></li>
                <li className="font-18 red"><span className="font-12 red_text">For existing folio, Client will have to get the new bank details updated with the respective Mutual Funds separately.</span></li>
              </ul>
              </span>
            </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
